import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { Form, Button, Row, Col } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { MonedasConstant } from 'constants/index'

import * as BackgroundJobsService from 'services/backgroundJobs.service'

import * as FormGroups from './formGroups'

export const ValidationSchema = Yup.object().shape({
  desdeMes: Yup.string().length(2).required(),
  hastaMes: Yup.string().length(2).required(),
  moneda: Yup.string().required()
})

const FormatoGastosPorCuenta = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      desdeMes: __adminContext.mesTrabajo || '',
      hastaMes: __adminContext.mesTrabajo || '',
      moneda: MonedasConstant.SOLES
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    async formData => {
      await BackgroundJobsService.iniciarReporteGastosPorCuenta(formData)
        .then(() => {
          __zariContext.snack('info', 'Reporte de gastos por cuenta enviado a procesos en background.')
        })
        .catch(({ data }) => __zariContext.snack('error', data?.error || 'No se pudo iniciar el proceso.'))
    },
    [__zariContext]
  )

  return (
    <>
      {__adminContext.mesTrabajo && (
        <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
          {({ errors, touched, isSubmitting, handleSubmit }) => (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroups.MesContabilidadFormGroup
                    idFormato='gastosPorCuenta-mes'
                    name='desdeMes'
                    label='DESDE MES'
                    iError={errors.desdeMes}
                    iTouched={touched.desdeMes}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.MesContabilidadFormGroup
                    idFormato='gastosPorCuenta-hasta'
                    name='hastaMes'
                    label='HASTA MES'
                    iError={errors.hastaMes}
                    iTouched={touched.hastaMes}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.MonedaFormGroup
                    iError={errors.moneda}
                    iTouched={touched.moneda}
                    fIsSubmitting={isSubmitting}
                  />
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button disabled={isSubmitting} onClick={handleSubmit}>
                        {isSubmitting ? 'Enviando proceso ...' : 'Generar en background'}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      )}
    </>
  )
}

export default React.memo(FormatoGastosPorCuenta)
